<template>
  <div>
    <div class="take-note" v-b-modal.modal-center @click="newNote = true">
      <span>+</span>
      <span>Take a Note</span>
    </div>

    <div class="notes-area">
      <notes
        v-for="(note, index) in notes"
        :key="index"
        :content="note.note"
        :activeColor="note.color"
        :ni="index"
        @changeNoteColor="changeColor"
        @editMe="modalValue"
        @deleteMe="deleteNote"
      />
    </div>

    <div class="take-note" v-b-modal.modal-center @click="newNote = true">
      <span>+</span>
      <span>Take a Note</span>
    </div>
    <div class="notes-area">
      <notes
        v-for="(note, index) in notes"
        :key="index"
        :content="note.note"
        :activeColor="note.color"
        :ni="index"
        @changeNoteColor="changeColor"
        @editMe="modalValue"
        @deleteMe="deleteNote"
      />
    </div>
  </div>
</template>

<script>
import ResourceBlockDisplay from "@/mixins/resourceBlocks/Display";
import Notes from "./notes";

export default {
  name: "Display_NotesBoard",
  mixins: [ResourceBlockDisplay],
  components: {
    Notes
  },
  mounted() {
    //THIS APPS SOUND EFFECTS -- onlyset up once
    if (this.settings_isSoundOn) {
      //switch it to hasSoundEffects or playSoundEffects
      this.setUpSoundEffects();
    }
  },
  computed: {
    settings_showProgressStats() {
      const _default = true;
      return this.settings && this.settings.user
        ? this.settings.user.isDisplayStats
        : _default;
    },
    settings_cardTheme() {
      return this.settings && this.settings.user
        ? this.settings.user.matchGroup
        : null;
    },
    settings_hasBgMusic() {
      return this.settings && this.settings.user
        ? this.settings.user.hasBGMusic
        : true;
    },
    settings_isSoundOn() {
      return this.settings && this.settings.user
        ? this.settings.user.isSoundOn
        : true;
    }
  },
  methods: {
    saveNote() {
      if (this.newNote) {
        this.notes.push({ note: this.note, color: 1 });
        this.newNote = false;
        return;
      } else {
        this.notes[this.currentNote].note = this.note;
      }
      this.note = "";
    },
    deleteNote(e) {
      this.notes.splice(e.ni, 1);
    },
    modalValue(e) {
      this.currentNote = e.ni;
      this.note = this.notes[e.ni].note;
    },
    changeColor(e) {
      this.notes[e.ni].color = e.ci;
    },
    setUpSoundEffects() {
      this.soundEffects.flip = new Audio(
        `${this.assetsURLHome}/_audio/effects/cardflip.wav`
      );
      this.soundEffects.successJingle = new Audio(
        `${this.assetsURLHome}/_audio/effects/success-jingle.ogg`
      );
    }
  },
  data() {
    return {
      note: "",
      currentNote: 0,
      notes: [],
      newNote: false,
      /* Overrides */
      assetsURLHome: "/assets/apps/notesboard/",
      /* App Specific */
      soundEffects: {
        flip: null,
        successJingle: null
      }
    };
  }
};
</script>

<style lang="scss" scoped>
/*.notes-area {
  margin: 0 5%;
  grid-auto-flow: row !important;
  grid-template-columns: 144px span 144px !important;
  grid-template-rows: repeat(auto-fill, 154px) !important;
}*/
.notes-area {
  float: right;
  margin-right: 24px;
  display: grid;

  grid-template-rows: 154px 154px;
  grid-gap: 10px;
  grid-template-columns: repeat(auto-fill, 144px);
  grid-auto-flow: column;
  justify-content: end;
  z-index: 500;
}
.take-note {
  cursor: pointer;
  position: absolute;
  top: 24px;
  right: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100px;
  height: 70px;
  background: rgba(255, 255, 255, 0.1);
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='white' stroke-width='2' stroke-dasharray='6' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");

  span {
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #ffffff;
  }
  &:hover {
    box-shadow: 0px 0px 4px 0px #888;
  }
}
</style>
